import LightBox from "componets/light-box/light-box";

export default LightBox
